import { Badge, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BsInfoCircle } from 'react-icons/bs';
import { useUserData } from 'hooks/api/useUser';
import { FUSDR_URL } from 'utils/general';

interface Props {
  model?: string;
}

export const FusdrBadge = ({ model }: Props) => {
  const { t } = useTranslation();
  const { data: userData } = useUserData();

  if (model && userData?.fdaAllowedDeviceModels?.some((item) => item.model === model)) {
    return <></>;
  }

  return (
    <Badge
      style={{ cursor: 'pointer' }}
      color={'blue'}
      size={'md'}
      radius={'lg'}
      variant={'filled'}
      rightSection={
        <Group>
          <BsInfoCircle size={12} />
        </Group>
      }
      onClick={(e) => {
        e.stopPropagation();
        window.open(FUSDR_URL, '_blank');
      }}
    >
      {t('patients_fusdr_patient')}
    </Badge>
  );
};
